module.exports = __webpack_public_path__ + "img/WP1_FurnaceSword.91cb34fb.png";